import { render, staticRenderFns } from "./OutrightsMenu.vue?vue&type=template&id=6f2f8c00"
import script from "./OutrightsMenu.vue?vue&type=script&lang=js"
export * from "./OutrightsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports